import {editStep} from '../../../actions/checkout'
import {FormStep} from '../../../constants'

export interface CouponInputOwnProps {
  mobile?: boolean
  currentStep: FormStep
}

export interface CouponInputRuntimeProps {
  editStep: typeof editStep
}

export interface CouponInputProps extends CouponInputRuntimeProps, CouponInputOwnProps {}

export enum CouponFormState {
  INITIAL = 'INITIAL',
  EDIT = 'EDIT',
  APPLIED = 'APPLIED',
}
